(ns pfo.download
  "Saving bytes from a session-authenticated endpoint to the user's disk.

  Its own namespace on purpose: controllers need it as much as components do, and
  reaching it through pfo.common.component would close a require cycle
  (common.component -> label.component -> pfo.controller -> a controller)."
  (:require [pfo.api :as api]))

(defn filename-from-response
  "Reads the name the server sent, or falls back. Both header forms are handled because a
  name outside ASCII arrives as filename*=UTF-8''."
  [resp fallback]
  (let [cd (.get (.-headers resp) "content-disposition")]
    (or (when cd
          (or (when-let [m (re-find #"filename\*=UTF-8''([^\s;]+)" cd)]
                (js/decodeURIComponent (second m)))
              (second (re-find #"filename=\"?([^\"]+)\"?" cd))))
        fallback)))

(defn save-blob-as-file [blob file-name mime-type]
  (let [obj-url (.createObjectURL (.-URL js/window)
                                  (js/File. (clj->js [blob]) file-name (clj->js {:type mime-type})))
        a       (.createElement js/document "a")]
    (set! (.-href a) obj-url)
    (set! (.-download a) file-name)
    (.appendChild (.-body js/document) a)
    (.click a)
    (.removeChild (.-body js/document) a)
    (.revokeObjectURL (.-URL js/window) obj-url)))

(defn fetch-and-save-file
  "Downloads bytes from an endpoint and saves them to disk. Name and type come from the
  response, so the caller needs to know neither -- which is what a file AARK created needs,
  since it names and types its own files. Returns a promise.

  A plain link cannot do this: the API authenticates from the Authorization header, which a
  browser navigation does not send."
  [ajax-url]
  (-> (js/fetch (api/api-url ajax-url) (clj->js {:headers (api/auth-headers)}))
      (.then (fn [resp]
               (if (.-ok resp)
                 (.then (.blob resp) (fn [blob] [blob resp]))
                 (js/Promise.reject {:status (.-status resp)}))))
      (.then (fn [[blob resp]]
               (let [file-name (filename-from-response resp "download")]
                 (save-blob-as-file blob
                                    file-name
                                    (or (.get (.-headers resp) "content-type")
                                        "application/octet-stream"))
                 ;; Resolved with the name the server sent, so a caller can name the file
                 ;; it just handed over without knowing it up front.
                 file-name)))))
